import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const CustomerCard = ({ data }) => {
  const history = useHistory();
  if (!data) return null;

  return (
    <div className="w-100">
      <span className="apps-grid-title">Patient</span>
      <div className="apps-grid-cell pointer">
        <article
          className="apps-card-app"
          onClick={() => history.push(`/customers/${data.id}`)}
        >
          <div className="apps-card-left">
            <div className="apps-card-meta">
              <h3 className="apps-card-app-title">
                {data.firstName} {data.lastName}
              </h3>
              <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                {data.email}
              </p>
              <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                {data.phone}
              </p>
              <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                {data.address}
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

CustomerCard.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    address: PropTypes.string,
  }),
};

export default CustomerCard;
